import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/commands/removerowcommand
 */
import { Command } from 'ckeditor5/src/core.js';
/**
 * The remove row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'removeTableRow'` editor command.
 *
 * To remove the row containing the selected cell, execute the command:
 *
 * ```ts
 * editor.execute( 'removeTableRow' );
 * ```
 */
var RemoveRowCommand = /*#__PURE__*/function (_Command) {
  _inherits(RemoveRowCommand, _Command);
  var _super = _createSuper(RemoveRowCommand);
  function RemoveRowCommand() {
    _classCallCheck(this, RemoveRowCommand);
    return _super.apply(this, arguments);
  }
  _createClass(RemoveRowCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var tableUtils = this.editor.plugins.get('TableUtils');
      var selectedCells = tableUtils.getSelectionAffectedTableCells(this.editor.model.document.selection);
      var firstCell = selectedCells[0];
      if (firstCell) {
        var table = firstCell.findAncestor('table');
        var tableRowCount = tableUtils.getRows(table);
        var lastRowIndex = tableRowCount - 1;
        var selectedRowIndexes = tableUtils.getRowIndexes(selectedCells);
        var areAllRowsSelected = selectedRowIndexes.first === 0 && selectedRowIndexes.last === lastRowIndex;
        // Disallow selecting whole table -> delete whole table should be used instead.
        this.isEnabled = !areAllRowsSelected;
      } else {
        this.isEnabled = false;
      }
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      var tableUtils = this.editor.plugins.get('TableUtils');
      var referenceCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
      var removedRowIndexes = tableUtils.getRowIndexes(referenceCells);
      var firstCell = referenceCells[0];
      var table = firstCell.findAncestor('table');
      var columnIndexToFocus = tableUtils.getCellLocation(firstCell).column;
      model.change(function (writer) {
        var rowsToRemove = removedRowIndexes.last - removedRowIndexes.first + 1;
        tableUtils.removeRows(table, {
          at: removedRowIndexes.first,
          rows: rowsToRemove
        });
        var cellToFocus = getCellToFocus(table, removedRowIndexes.first, columnIndexToFocus, tableUtils.getRows(table));
        writer.setSelection(writer.createPositionAt(cellToFocus, 0));
      });
    }
  }]);
  return RemoveRowCommand;
}(Command);
/**
 * Returns a cell that should be focused before removing the row, belonging to the same column as the currently focused cell.
 * - If the row was not the last one, the cell to focus will be in the row that followed it (before removal).
 * - If the row was the last one, the cell to focus will be in the row that preceded it (before removal).
 */
export { RemoveRowCommand as default };
function getCellToFocus(table, removedRowIndex, columnToFocus, tableRowCount) {
  // Don't go beyond last row's index.
  var row = table.getChild(Math.min(removedRowIndex, tableRowCount - 1));
  // Default to first table cell.
  var cellToFocus = row.getChild(0);
  var column = 0;
  var _iterator = _createForOfIteratorHelper(row.getChildren()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tableCell = _step.value;
      if (column > columnToFocus) {
        return cellToFocus;
      }
      cellToFocus = tableCell;
      column += parseInt(tableCell.getAttribute('colspan') || '1');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return cellToFocus;
}